import { css } from 'linaria';

export const dynamicCategoryRendererStyle = css`
  width: 100%;
`;
